import * as React from "react";
function SvgVenusSolid(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M18.429 8.429A6.43 6.43 0 0012 2a6.43 6.43 0 00-1.429 12.696V17H8.964a.537.537 0 00-.535.536v1.785c0 .295.24.536.535.536h1.607v1.607c0 .295.242.536.536.536h1.786a.537.537 0 00.536-.536v-1.607h1.607a.537.537 0 00.535-.536v-1.785a.537.537 0 00-.535-.536h-1.607v-2.304a6.43 6.43 0 005-6.267zm-10 0A3.576 3.576 0 0112 4.857a3.576 3.576 0 013.571 3.572A3.576 3.576 0 0112 12a3.576 3.576 0 01-3.571-3.571z"
        fill="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgVenusSolid);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
